import OpportunityDetails from './opportunityDetails.view';

export default OpportunityDetails;
